import React from 'react';
import { Box, Modal, IconButton, Typography, Divider, Grid, Paper } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 900,
    maxHeight: '90vh',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    boxShadow: 24,
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
};

const actionColors = {
    "List": { color: "#3498db", bg: "#ebf5fb", border: "#85c1e9" },
    "Create": { color: "#3498db", bg: "#ebf5fb", border: "#85c1e9" },
    "Edit": { color: "#f39c12", bg: "#fef5e7", border: "#f8c471" },
    "Delete": { color: "#e74c3c", bg: "#fdedec", border: "#f1948a" },
};

const PermissionViewDialogue = () => {
    const dispatch = useDispatch();
    const { dialogue: open, dialogueData } = useSelector((state) => state.dialogue);

    const handleClose = () => {
        dispatch({ type: "CLOSE_DIALOGUE" });
    };

    if (!dialogueData) return null;

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <div className="bg-white" style={{ borderRadius: '12px 12px 0 0' }}>
                    <div className="d-flex justify-content-between align-items-center p-3">
                        <div className="headerTitle fw-bold text-white">
                            <div >
                                View Permissions
                            </div>
                            <div className='text-muted' style={{ fontSize: '16px' }}>
                                Role: {dialogueData.name}
                            </div>
                        </div>
                       <div
                        className="closeBtn "
                        onClick={handleClose}
                    >
                        <i class="fa-solid fa-xmark"></i>
                    </div>
                    </div>
                    <Divider />
                </div>

                <div className="p-4" style={{ overflowY: 'auto' }}>
                    <Grid container spacing={3}>
                        {dialogueData.permissions.map((perm, idx) => (
                            <Grid item xs={12} md={6} key={idx}>
                                <Paper elevation={0} sx={{ 
                                    p: 2.5, 
                                    borderRadius: '12px', 
                                    border: '1px solid #eaeaea',
                                    height: '100%' 
                                }}>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="d-flex align-items-center">
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                                {perm.module}
                                            </Typography>
                                        </div>
                                        <Box sx={{ 
                                            bgcolor: '#f1f3f4', 
                                            px: 1.5, 
                                            py: 0.5, 
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#5f6368'
                                        }}>
                                            {perm.actions.length} Actions
                                        </Box>
                                    </div>
                                    <Divider sx={{ mb: 2, borderStyle: 'dashed' }} />
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {perm.actions.map(action => {
                                            const styling = actionColors[action] || { color: "#555", bg: "#eee", border: "#ccc" };
                                            return (
                                                <Box
                                                    key={action}
                                                    sx={{
                                                        px: 1.5,
                                                        py: 0.5,
                                                        borderRadius: '20px',
                                                        fontSize: '12px',
                                                        fontWeight: 500,
                                                        color: styling.color,
                                                        border: `1px solid ${styling.border}`,
                                                        bgcolor: 'transparent'
                                                    }}
                                                >
                                                    {action}
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                        
                        {dialogueData.permissions.length === 0 && (
                            <Grid item xs={12}>
                                <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                                    No permissions assigned to this role.
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </Box>
        </Modal>
    );
};

export default PermissionViewDialogue;
